import { userInfoSync } from 'hub-http/userInfo';
const safeGetUserInfo = () => {
  try {
    return userInfoSync();
  } catch (error) {
    return undefined;
  }
};
const getUserLimits = () => {
  var _safeGetUserInfo;
  return (_safeGetUserInfo = safeGetUserInfo()) === null || _safeGetUserInfo === void 0 || (_safeGetUserInfo = _safeGetUserInfo.portal) === null || _safeGetUserInfo === void 0 ? void 0 : _safeGetUserInfo.limits;
};
export const getUserId = () => {
  var _safeGetUserInfo2;
  return (_safeGetUserInfo2 = safeGetUserInfo()) === null || _safeGetUserInfo2 === void 0 || (_safeGetUserInfo2 = _safeGetUserInfo2.user) === null || _safeGetUserInfo2 === void 0 ? void 0 : _safeGetUserInfo2.user_id;
};
export const getStrategiesLimit = () => {
  var _getUserLimits;
  return ((_getUserLimits = getUserLimits()) === null || _getUserLimits === void 0 ? void 0 : _getUserLimits['personalization-max-strategies']) || 0;
};

// TODO: replace with quartz getGates() when all apps are migrated to quartz
let memoizedGates = undefined;
const getGates = () => {
  if (!memoizedGates) {
    var _safeGetUserInfo3;
    memoizedGates = new Set((_safeGetUserInfo3 = safeGetUserInfo()) === null || _safeGetUserInfo3 === void 0 ? void 0 : _safeGetUserInfo3.gates);
  }
  return memoizedGates;
};
export const hasGate = _gate => getGates().has(_gate);

// TODO: replace with quartz getScopes() when all apps are migrated to quartz
let memoizedScopes = undefined;
const getScopes = () => {
  if (!memoizedScopes) {
    var _safeGetUserInfo4;
    memoizedScopes = new Set((_safeGetUserInfo4 = safeGetUserInfo()) === null || _safeGetUserInfo4 === void 0 || (_safeGetUserInfo4 = _safeGetUserInfo4.user) === null || _safeGetUserInfo4 === void 0 ? void 0 : _safeGetUserInfo4.scopes);
  }
  return memoizedScopes;
};
export const hasScope = scope => getScopes().has(scope);
export const hasScopes = scopes => scopes.every(scope => hasScope(scope));

/** DO NOT USE: Exported only for testing purposes */
export const resetMemoizedAuth = () => {
  memoizedGates = undefined;
  memoizedScopes = undefined;
};